import { ILocaleConfig } from "@/config/locale.config";
import { SupportedLocale, LocaleToLabelMap } from "@/enums/locale.enum";

// Ukraine-specific locale configuration
const ukraineLocaleConfig: ILocaleConfig = {
  supportedLocales: [SupportedLocale.RU, SupportedLocale.EN],
  defaultLocale: SupportedLocale.RU,
  languageTabs: [
    {
      key: SupportedLocale.RU,
      label: LocaleToLabelMap.get(SupportedLocale.RU)!,
    },
    {
      key: SupportedLocale.EN,
      label: LocaleToLabelMap.get(SupportedLocale.EN)!,
    },
  ],
};

export default ukraineLocaleConfig;
